<script>
    import { fade } from "svelte/transition";
    import Error from "./Error.svelte";
    import Navbar from "./Navbar.svelte";
    
    import * as json from "./Biography.json";
    const biographies = json.default;

    const animation = 500;

    let page = "alraiti";
    let submenus = [];
    for (let i in biographies) { submenus.push({ name: biographies[i].name, page: i, }); }

    $: selected = biographies[page];
    $: image = selected.image;
</script>

<div class="main">
    <div class="buttons">
        <Navbar {submenus} bind:page></Navbar>
    </div>
    {#key page}
        {#await new Promise(resolve => setTimeout(resolve, animation))}
            <img
                on:error="{() => image = false}"
                class="image"
                src="data/images/pfp/{image}"
                alt="Profile"
                style="display: none;"
            />
        {:then f}
            <div class="bio" transition:fade={{ duration: animation }}>
                {#if image}
                    <img
                        on:error="{() => image = false}"
                        class="image"
                        src="data/images/pfp/{image}"
                        alt="Profile"
                    />
                {:else}
                    <div class="image">
                        <Error></Error>
                    </div>
                {/if}
                <p class="text">{@html selected.bio}</p>
            </div>
        {/await}
    {/key}
</div>

<style>
    .main {
        /** Object propeties*/
        display: grid;
        row-gap: 15px;
        width: 100%;

        text-align: center;
    }

    .bio {
        grid-row: 2;
        margin: auto;
    }

    .image {
        border-radius: 50%;
        margin: auto;
        
        min-width: 150px;
        width: 10vw;
        height: auto;
    }

    .text {
        width: 70vw;
    }
</style>
